export default __webpack_public_path__ + "static/media/new-window.d9276317.png";